import { hasNoStopDateInput, type StopReasonPolicyDates } from '@folio/utils/stop-reasons';
import type { ConfigPolicyStopReasonDto } from 'korint-sdk';

export type EffectiveDate =
  | { kind: 'VOIDED_AT_START'; at?: string }
  | { kind: 'NEXT_ANNIVERSARY'; at?: string }
  | { kind: 'NOW'; at?: string }
  | { kind: 'CHOSEN'; at?: string };

// FULL-refund and no-stop-date reasons take no input: the backend derives the date and ignores any.
export const resolveEffectiveDate = ({
  reason,
  policy,
  stopDate,
}: {
  reason?: ConfigPolicyStopReasonDto;
  policy: StopReasonPolicyDates;
  stopDate?: string;
}): EffectiveDate => {
  if (!reason) {
    return { kind: 'CHOSEN', at: stopDate };
  }
  if (reason.refundType === 'FULL') {
    return { kind: 'VOIDED_AT_START', at: policy.startedAt };
  }
  if (hasNoStopDateInput(reason)) {
    return { kind: 'NEXT_ANNIVERSARY', at: policy.nextRenewalAt };
  }
  // No appliedAtDate key to read a date from: the backend stamps the request instant instead, and
  // the draft already holds the one it stamped.
  if (!reason.appliedAtDate) {
    return { kind: 'NOW', at: stopDate };
  }
  return { kind: 'CHOSEN', at: stopDate };
};

/** Only a CHOSEN date is the requester's to pick; every other kind the backend derives itself. */
export const asksForADate = (effectiveDate: EffectiveDate): boolean =>
  effectiveDate.kind === 'CHOSEN';

// A derived anchor the policy cannot supply leaves `at` empty too, and submitting that stops the
// policy on whatever date the caller falls back to.
export const isEffectiveDateComplete = (effectiveDate: EffectiveDate): boolean =>
  !!effectiveDate.at;
